export const all_routes = {
  home: "/index",

  // Blog Routes
  blogGrid: "/blog/blog-grid",
  blogGridSidebarRight: "/blog/blog-grid-sidebar-right",
  blogGridSidebarLeft: "/blog/blog-grid-sidebar-left",
  blogList: "/blog/blog-list",
  blogListSidebarRight: "/blog/blog-list-sidebar-right",
  blogListSidebarLeft: "/blog/blog-list-sidebar-left",
  blogCarousel: "/blog/blog-carousel",
  blogDetails: "/blog/blog-details",
  blogDetailsSidebarRight: "/blog/blog-details-sidebar-right",
  blogDetailsSidebarLeft: "/blog/blog-details-sidebar-left",

  // Pages Routes
  aboutUs: "/pages/about-us",
  comingSoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  events: "/pages/events",
  eventdetails: "/pages/event-details",
  serviceDetail: "/pages/service-detail",
  services: "/pages/services",
  termsCondition: "/pages/terms-condition",
  testimonials: "/pages/testimonials",
  testimonialsCarousel: "/pages/testimonials-carousel",
  maintenance: "/pages/maintenance",
  privacyPolicy: "/pages/privacy-policy",
  pricing: "/pages/pricing",
  ourTeams: "/pages/our-teams",
  myProfile: "/pages/my-profile",
  faq: "/pages/faq",
  gallery: "/pages/gallery",
  invoice: "/coaches/invoice",
  lessonOrderConfirm: "/coaches/lesson-order-confirm",
  lessonPayment: "coaches/lesson-payment",
  lessonPersonalinfo: "coaches/lesson-personalinfo",
  userWallet: "/user/user-wallet",

  // Coaches Routes
  bookingCancelled: "/coaches/booking-cancelled",
  bookingCompleted: "/coaches/booking-completed",
  allCourt: "/coaches/all-court",
  appointmentDetails: "/coaches/appointment-details",
  addCourt: "/coaches/add-court",
  activeCourt: "/coaches/active-court",
  inactiveCourt: "/coaches/inactive-court",
  coachDetail: "/coaches/coach-detail",
  coachDetails: "/coaches/coach-details",
  coachEarning: "/coaches/coach-earning",
  coachesGrid: "/coaches/coaches-grid",
  coachesGridSidebar: "/coaches/coaches-sidebar-grid",
  coachesList: "/coaches/coaches-list",
  coachesListSidebar: "/coaches/coaches-sidebar-list",
  coachesMap: "/coaches/coaches-map",
  coachRequest: "/coaches/coach-request",
  coachWallet: "/coaches/coach-wallet",
  coachTimeDate: "/coaches/coach-timedate",
  coachProfile: "/coaches/coach-profile",
  coachPersonalInfo: "/coaches/coach-personalinfo",
  coachPayment: "/coaches/coach-payment",
  coachOrederConfirm: "/coaches/coach-order-confirm",
  coachesMapSidebar: "/coaches/coaches-map-sidebar",
  earningCoaching: "/coaches/earning-coaching",
  cagecheckout: "/coaches/cage-checkout",
  cagedetails: "/coaches/cage-details",
  cageordeconfirm: "/coaches/cage-order-confirm",
  cagepersonalinfo: "/coaches/cage-personalinfo",
  lessonTimeDate: "/coaches/lesson-timedate",
  lessonType: "/coaches/lesson-type",
  settingLesson: "/coaches/setting-lesson",
  settingPassword: "/coaches/setting-password",
  settingAvalibilty: "/coaches/setting-availability",
  profileOtherSetting: "/coaches/profile-othersetting",
  coachDashboard: "coaches/coach-dashboard",
  coachBooking: "/coaches/coach-booking",
  coachChat: "/coaches/coach-chat",
  venueDetails: "/coaches/venue-details",

  // User Routes
  userComplete: "/user/user-complete",
  userDashboardProfiles: "/user/user-dashboard-profiles",
  userDashboard: "/user/user-dashboard",
  userInvoice: "/user/user-invoice",
  userBookings: "/user/user-bookings",
  userChat: "/user/user-chat",
  userCoaches: "/user/user-coaches",
  userProfile: "/user/user-profile",
  userSettingPassword: "/user/user-setting-password",
  userProfileOtherSetting: "/user/user-profile-othersetting",
  userCancelled: "/user/user-cancelled",
  userOngoing: "/user/user-ongoing",

  // Listing Routes
  listingGridSidebar: "/listing/listing-grid-sidebar",
  listingGrid: "/listing/listing-grid",
  listingListSidebar: "/listing/listing-list-sidebar",
  listingList: "/listing/listing-list",
  listingMapSidebar: "/listing/listing-map-sidebar",
  listingMap: "/listing/listing-map",

  // Auth Routes
  register: "/auth/register",
  login: "/auth/login",
  changePassword: "/auth/change-password",
  forgotPasssword: "/auth/forgot-password",

  // added screens

  dashboard: "/manipur/dashboard",

  tenviclogin: "/tenvic/login",
  tenvicForgotPassword: "/tenvic/forgotpassword",
  tenvicUsers: "/tenvic/users",
  tenvicRoles: "/tenvic/role",
  tenvicPermissions: "/tenvic/permission",
  tenvicRolePermissions: "/tenvic/rolepermission",
  tenvicMenus: "/tenvic/menu",
  tenvicSubMenus: "/tenvic/submenu",
  tenvicMenuRole: "/tenvic/menurole",
  tenvicProfile: "/tenvic/profile",
  tenvicPasswordReset: "/tenvic/passwordreset/:token",
  tenvicUserRBAC: "/tenvic/userrbac",
  tenvicClients: "/tenvic/clientinfo",


  manipurlogin: "/manipur/login",
  manipurForgotPassword: "/manipur/forgotpassword",
  manipurUsers: "/manipur/users",
  manipurRoles: "/manipur/role",
  manipurAccountType: "/manipur/accounttype",
  manipurPermissions: "/manipur/permission",
  manipurRolePermissions: "/manipur/rolepermission",
  manipurMenus: "/manipur/menu",
  manipurSubMenus: "/manipur/submenu",
  manipurProfile: "/manipur/profile",
  manipurPasswordReset: "/manipur/passwordreset/:token",
  manipurUserRBAC: "/manipur/userrbac",
  manipurSports: "/manipur/sports",
  manipurTalentScout: "/manipur/talentscout",
  manipurTalentScoutCriteria: "/manipur/talentscoutcriteria",
  manipurGeography: "/manipur/geography",
  manipurBatch: "/manipur/batches",
  manipurBatchAthlete: "/manipur/batchathlete",
  manipurTlntSctAthlt: "/manipur/approveathlete",
  manipurSchedule: "/manipur/testschedule",
  manipurAssessment: "/manipur/assessment",
  manipurCompetitionType: "/manipur/competitiontype",
  manipurCompetitionSports: "/manipur/compsport",
  manipurCompetitionSportType: "/manipur/sporttype",
  manipurCompetition: "/manipur/competitions",
  manipurCompetitionPerformance: "/manipur/compperformance",
  manipurCompetitionSettings:"/manipur/eventsetting",
  manipurSportsList: "/manipur/compsportList",
  manipurAllAthletes: "/manipur/athlete",
  manipurCenterAthletes: "/manipur/centerathletes",
  manipurHPCAthletes: "/manipur/hpcathletes",
  manipurProgramLevel: "/manipur/programlevel",
  manipurSkills: "/manipur/skills",
  manipurScheduleType: "/manipur/scheduletype",
  manipurGradeType:"/manipur/gradetype",
  manipurAssessmentType:"/manipur/assessmenttype",
  manipurAttendanceType:"/manipur/attendancetype",
  manipurGender:"/manipur/gender",
  manipurLevel:"/manipur/level",
  manipurCountry:"/manipur/countries",
  manipurJoint:"/manipur/joints",
  manipuMovement:"/manipur/movements",

  manipurCenterBatch: "/manipur/centerbatch",
  manipurCenterBatchAthlete: "/manipur/centerathlete",
  manipurCenterSchedule: "/manipur/centerschedule",
  manipurCenterAttendance: "/manipur/centerattendance",
  manipurCenterAssessment: "/manipur/centerassessment",
  manipurCenterAthleteApprove: "/manipur/approvecenterathlete",

  manipurHPCAthlete: "/manipur/athletesbyhpc",

  manipurHPCBatch: "/manipur/hpcbatch",
  manipurHPCBatchAthlete: "/manipur/hpcbatchathlete",
  manipurHPCSchedule: "/manipur/hpcschedule",
  manipurHPCAttendance: "/manipur/hpcattendance",
  manipurHPCAssessment: "/manipur/hpcassessment",

  manipurAthleteMetrics: "/manipur/metricanalysis",

  manipurCompetitionsReport: "/manipur/competitionreport",
  manipurCompetitionPerformanceReport: "/manipur/compperformancereport",
  manipurAthleteReport: "/manipur/athletereport",
  manipurScheduleReport: "/manipur/schedulereport",
  manipurTestResultsReport: "/manipur/assessmentreport",

  manipurInjury: "/manipur/injury",
  manipurInjuryAssessment: "/manipur/injuryassessment",
  manipurInjuryDiagnosis:"/manipur/diagnosis",
  manipurInjuryTreatment:"/manipur/treatmentplan",
  manipurScreening:"/manipur/screening",

  manipurBldGrp:"/manipur/bloodgroup",
  manipurAlrgyTyp:"/manipur/allergytype",
  manipurMedCtgry:"/manipur/medicationcategory",
  manipurAlcUse:"/manipur/alcoholusage",
  manipurTbcoUse:"/manipur/tobaccousage",
  manipurInjTyp:"manipur/injurytype",
  manipurRgnAfctd:"/manipur/regionaffected",
  manipurDiagType:"/manipur/diagnosistype",
  manipurInjSvrty:"/manipur/injuryseverity",
  manipurInjMech:"/manipur/mechanisminjury",
  manipurInjMgmt:"/manipur/injurymanagementapproach",
  manipurTimeLost:"/manipur/timelostfromtraining",
  manipurSurgCtgry:"/manipur/surgerycategory",
  manipurBdyRgn:"/manipur/bodyregion",
  manipurRehabDur:"/manipur/rehabilitationduration",
  manipurPhysioType:"/manipur/physiologicaltype",
  manipurScrnTstTyp:"/manipur/screeningtesttype",
  manipurSympTyp:"/manipur/symptomtype",
  manipurPainLocTyp:"/manipur/painlocationtype",
  manipurFuncLmt:"/manipur/functionallimitationstype",
  manipurInjTreatTyp:"/manipur/injurytreatmenttype",
  manipurCncsnSymp:"/manipur/concussionspecificsymptom",
  manipurOnst:"/manipur/onset",
  manipurPrfrmTst:"/manipur/performancetest",
  manipurAsgnCntr:"/manipur/assigncenter",
  manipurAsgnHPC:"/manipur/assignhpc",
  manipurOverAllAssessment:"/manipur/detailedassessment",
  manipurPsychology:"/manipur/psychology",
  manipurPsychologyAcsi:"/manipur/acsi",
  manipurExternalSports:"/manipur/extsport",
  manipurExtCompRsltFrmt:"/manipur/extresultformat",
  manipurExtCompCtgry:"/manipur/extcategory",
  manipurLevels:"/manipur/extgeography",
  manipurExtComp:"/manipur/extcompetition",
  manipurExtCompSettings:"/manipur/exteventsetting",

  manipurAthletes: "/athleteregister",
  manipurAthletesRegs: "/register",

  athleteLogin: "/athlete/login",
  athleteDashboard: "/athlete/dashboard",
  athleteMetrics: "/athlete/metricanalysis",
  athleteProfile: "/athlete/profile",

  athleteInjury: "/athlete/injury",
  athleteInjuryAssessment: "/athlete/injuryassessment",
  athleteInjuryDiagnosis:"/athlete/diagnosis",
  athleteInjuryTreatment:"/athlete/treatmentplan",
  athleteScreening:"/athlete/screening",

  athleteBatch: "athlete/batches",
  athleteBatchAthlete: "athlete/batchathlete",
  athleteSchedule: "athlete/testschedule",
  athleteAssessment: "athlete/assessment",
  athleteCenterBatch: "/athlete/centerbatch",
  athleteCenterBatchAthlete: "/athlete/centerathlete",
  athleteCenterSchedule: "/athlete/centerschedule",
  athleteCenterAttendance: "/athlete/centerattendance",
  athleteCenterAssessment: "/athlete/centerassessment",
  athleteHPCBatch: "/athlete/hpcbatch",
  athleteHPCBatchAthlete: "/athlete/hpcbatchathlete",
  athleteHPCSchedule: "/athlete/hpcschedule",
  athleteHPCAttendance: "/athlete/hpcattendance",
  athleteHPCAssessment: "/athlete/hpcassessment",
  athleteCompetitionPerformance: "/athlete/compperformance",
  athleteExternalCompetitions: "/athlete/extcompetition",

  //contact-us
  contactUs: "/contact-us",
};
